"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWarningAlert = exports.WarningAlert = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Alert_1 = require("./Alert");
const useAlert_1 = require("./useAlert");
const WarningAlert = (props) => {
    return jsx_runtime_1.jsx(Alert_1.Alert, Object.assign({}, props), void 0);
};
exports.WarningAlert = WarningAlert;
function useWarningAlert(_a = {
    Component: exports.WarningAlert,
}) {
    var { Component } = _a, props = tslib_1.__rest(_a, ["Component"]);
    if (!Component) {
        Component = exports.WarningAlert;
    }
    const { alert: warningAlert, setAlert: setWarningAlert } = useAlert_1.useAlert(Object.assign({ Component }, props));
    return { warningAlert, setWarningAlert };
}
exports.useWarningAlert = useWarningAlert;
//# sourceMappingURL=WarningAlert.js.map